var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center pa-12 mt-7"},[_vm._v("Tippings.me was made with ❤ by Tell!. Copyright 2021.")])}
var staticRenderFns = []

export { render, staticRenderFns }